import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameLoaderService } from '../services/gameLoaderService';

const Game: React.FC = observer(() => {
  var game = gameLoaderService.game;
  if (game) {
    return <game.GameComponent />;
  } else {
    // Return loading
    return <>Loading game...</>;
  }
});

export default Game;
